import { render, staticRenderFns } from "./tabsexample.vue?vue&type=template&id=6cf6e9c6&scoped=true&"
import script from "./tabsexample.vue?vue&type=script&lang=js&"
export * from "./tabsexample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6e9c6",
  null
  
)

export default component.exports